import DataTable from "datatables.net-dt";
import "datatables.net-fixedheader-dt";

export const reportElements = ["fcst", "res", "snow", "prec"];
export const monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
export const monthLongNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export function showLoadingBar(show = true) {
    const loading = document.getElementById("loading-bar");
    if (show) {
        loading.classList.remove("fsa-hide");
    } else {
        loading.classList.add("fsa-hide");
    }
}

export function getYear() {
    return document.getElementById("year-dd").selectedOptions[0].value;
}

export function getWaterYear() {
    const year = document.getElementById("year-dd").selectedOptions[0].value;
    const month = document.getElementById("month-dd").selectedOptions[0].value;
    if (month > 9) {
        return `${Number(year) + 1}`;
    }
    return year;
}

export function getMonth() {
    return document.getElementById("month-dd").selectedOptions[0].value;
}

export function getLongLastMonth() {
    const month = document.getElementById("month-dd").selectedOptions[0].value;
    const index = Number(month) - 2;
    if (index > -1) {
        return monthLongNames[index];
    }
    return monthLongNames[monthLongNames.length + index];
}

export function getLongMonth() {
    const month = getMonth();
    if (month === "0") {
        return monthLongNames[monthLongNames.length - 1];
    }
    return monthLongNames[month - 1];
}

export function clearBasins() {
    document.getElementById("basin-dd").innerHTML = "";
}

export function checkPubDate() {
    const month = getMonth() - 1;
    const year = getYear();
    const currDate = new Date();
    const reportDate = new Date(year, month, 1);
    if (reportDate > currDate) {
        return false;
    }
    return true;
}

export function wsorDataEmpty(wsorData) {
    const siteCnt = Object.keys(wsorData?.site_meta ? wsorData.site_meta : {});
    if (siteCnt.length === 0) {
        return true;
    }
    return false;
}

export function convertToValidFilename(origFilename) {
    return origFilename.replace(/[\[!\/|\\:*?"<> \]]/g, "").toLowerCase();
}

export function updateSearchParams(queryArgs) {
    const loc = window.location;
    let url = `${loc.protocol}//${loc.host}${loc.path ? loc.path : ""}${loc.pathname}`;
    let queryString = "";
    Object.keys(queryArgs).forEach((argKey, idx) => {
        queryString += `${idx ? "&" : ""}${argKey}=${queryArgs[argKey]}`;
    });
    url += queryString ? `?${queryString}` : "";
    history.replaceState({}, "", url);
}

export function getBasinType(wsorData, basinType) {
    //since we do not enforce distinct names between major/minor/misc sometimes we end up with more than one wsorData item with the same name
    if (wsorData.length == 1) {
        return wsorData[0];
    }
    let correctBasinData = {};
    wsorData.forEach((data) => {
        if (basinType === "minor" && data["basin_meta"]["btype"].endsWith("2_8")) {
            correctBasinData = data;
        } else if (basinType === "major" && data["basin_meta"]["btype"].endsWith("_8")) {
            correctBasinData = data;
        } else if (basinType === "misc" && data["basin_meta"]["btype"].endsWith("3")) {
            correctBasinData = data;
        }
    });
    return correctBasinData;
}

export function setReportToggles(reportType, hasData = true) {
    const toggle = document.getElementById(`show-report--${reportType}`);
    toggle.checked = toggle.checked || toggle.disabled ? hasData : false;
    toggleReport(toggle);
    adjustHeaders();
    toggle.disabled = !hasData;
}

export function toggleReport(toggle) {
    const reportType = toggle.id.split("--")[1];
    const reportDiv = document.getElementById(`${reportType}--report`);
    if (toggle.checked) {
        reportDiv.classList.add("fsa-show");
        reportDiv.classList.remove("fsa-hide");
    } else {
        reportDiv.classList.add("fsa-hide");
        reportDiv.classList.remove("fsa-show");
    }
    adjustHeaders();
}

export function clearReports(reports = reportElements) {
    showTables(false);
    reports.forEach((rpt) => {
        const tableId = `${rpt}Table`;
        removeDataTableFunctions(tableId);
        const rptTable = document.getElementById(rpt);
        if (rptTable) {
            rptTable.innerHTML = "";
        }
        adjustHeaders();
    });
}

export function adjustHeaders() {
    let options = { visible: false, api: true };
    DataTable.tables(options).fixedHeader.adjust();
    DataTable.tables(options).draw();
}

export function showTables(show = true) {
    const results = document.getElementById("results");
    show ? results.classList.remove("fsa-hide") : results.classList.add("fsa-hide");
}

export function removeDataTableFunctions(tableId) {
    document.getElementById(tableId) && window[tableId]?.destroy();
}
